import api from "./api";

export const chatAPI = {
  // Get contacts directory (admins and members)
  getContacts: async (params) => {
    const res = await api.get("/chat/contacts", { params });
    return res.data;
  },

  // Get recent conversations
  getConversations: async () => {
    const res = await api.get("/chat/conversations");
    return res.data;
  },

  // Get unread messages count
  getUnreadCount: async () => {
    const res = await api.get("/chat/unread-count");
    return res.data;
  },

  // Get messages for conversation
  getMessages: async (conversationId) => {
    const res = await api.get(`/chat/conversations/${conversationId}/messages`);
    return res.data;
  },

  // Send a direct message
  sendMessage: async ({ recipientId, conversationId, body, attachments, tempId }) => {
    const res = await api.post("/chat/messages", {
      recipientId,
      conversationId,
      body,
      attachments,
      tempId,
    });
    return res.data;
  },

  // Mark conversation as read
  markAsRead: async (conversationId) => {
    const res = await api.put(`/chat/conversations/${conversationId}/read`);
    return res.data;
  },

  // Upload attachments
  uploadAttachments: async (formData) => {
    const res = await api.post("/chat/upload", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return res.data;
  },
};
